import { useState } from "react";

const faqData = [
  {
    question: "Do you offer water purifier uninstallation services in Patna?",
    answer:
      "Yes. We provide professional water purifier uninstallation services across Patna for all major brands."
  },
  {
    question: "What does the regular water purifier service cost in Patna?",
    answer:
      "Regular service starts from affordable prices depending on your purifier type and service requirements."
  },
  {
    question: "When should you schedule a water purifier service in Patna?",
    answer:
      "We recommend servicing every 3–6 months to maintain water quality and purifier performance."
  },
  {
    question: "Which water purifier has the lowest service cost in Patna?",
    answer:
      "Service cost depends on the purifier model, but we provide affordable servicing for all major brands."
  },
  {
    question: "Do you provide Kent RO service in Patna?",
    answer:
      "Yes. We provide complete Kent RO installation, repair, AMC, filter replacement and maintenance services."
  }
];

const FAQ = () => {
  const [active, setActive] = useState(null);

  const toggleFAQ = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">

        <div className="faq-header">
          <h2>Frequently Asked Questions</h2>
          <p>Find answers to common questions about our services</p>
        </div>

        <div className="faq-list">

          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${active === index ? "active" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{item.question}</span>

                <svg
                  className="faq-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>

              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default FAQ;